<template>
  <div class="update">
    <div class="header">
      <van-icon
        size="20"
        class="arrow-left"
        @click="getBack"
        name="arrow-left"
      />
      <img src="../../assets/Login/update-bg.png" alt="" />
    </div>
    <van-form
      v-if="updateNext1"
      @submit="updateNext"
      :model="updateForm"
      ref="updateForm"
      style="padding: 0px 25px"
    >
      <van-field
        style="font-size: 16px"
        v-model="updateForm.phone"
        placeholder="请输入手机号"
        :left-icon="mobilePhone"
        :rules="[
          {
            validator: validatorPhonenumber,
            required: true,
            message: '请输入正确的手机号',
          },
        ]"
      >
      </van-field>
      <van-field
        style="font-size: 16px; margin-top: 25px"
        v-model="updateForm.code"
        :left-icon="mobileCode"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '' }]"
      >
        <template #button>
          <van-button
            v-show="verShow1"
            native-type="button"
            size="small"
            class="code"
            @click="sendSms"
            >获取验证码</van-button
          >
          <van-button v-show="verShow2" native-type="button" size="small"
            ><span>{{ timer }}</span
            >秒后重新获取</van-button
          >
        </template>
      </van-field>
      <div style="margin: 80px 30px 0">
        <van-button block native-type="submit" class="submit"
          >下一步</van-button
        >
      </div>
    </van-form>

    <van-form
      v-if="updateNext2"
      @submit="onSubmit"
      :model="updateForm"
      ref="updateForm"
      style="padding: 0px 25px"
    >
      <van-field
        style="font-size: 16px; margin-top: 25px"
        v-model="updateForm.password"
        type="password"
        placeholder="请输入新密码"
        :left-icon="mobilePassword"
        :rules="[
          {
            validator: validatorPassword,
            required: true,
            message: '请输入6-10位字母或数字',
          },
        ]"
      />
      <van-field
        style="font-size: 16px; margin-top: 25px"
        v-model="updateForm.passwordConfirm"
        type="password"
        placeholder="请确认新密码"
        :left-icon="mobilePassword"
        :rules="[
          {
            validator: validatorPassword,
            required: true,
            message: '请输入6-10位字母或数字',
          },
        ]"
      />
      <div style="margin: 80px 30px 0">
        <van-button class="submit" block native-type="submit"
          >确认修改</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { sendSms, updateNext, update } from "../../api/login";
import { Toast } from "vant";
import mobilePhone from "../../assets/Login/phone.png";
import mobilePassword from "../../assets/Login/password.png";
import mobileCode from "../../assets/Login/code.png";
import mobileUser from "../../assets/Login/user.png";

export default {
  name: "update",
  data() {
    return {
      mobilePhone,
      mobilePassword,
      mobileCode,
      mobileUser,
      updateForm: {
        phone: "",
        code: "",
        password: "",
        passwordConfirm: "",
      },
      token: "",
      verShow1: true,
      verShow2: false,
      timer: 59,
      updateNext1: true,
      updateNext2: false,
      phone: "",
    };
  },

  created() {
    this.updateForm.phone = this.$route.query.p;
  },
  methods: {
    // 修改密码
    onSubmit() {
      if (this.updateForm.password != this.updateForm.passwordConfirm) {
        Toast.fail("两次密码输入不一致");
        return;
      }
      update({
        phonenumber: this.updateForm.phone,
        password: this.updateForm.password,
      }).then((response) => {
        if (response == undefined) {
          Toast.fail({
            message: "修改密码失败，请重试",
            duration: 1500,
          });
        }
        if (response.code === 200) {
          Toast.success("修改密码成功");
          window.localStorage.setItem("password", this.updateForm.password);
          this.$router.push(`/login`)
        } else {
          Toast.fail(response.msg);
        }
      });
    },
    // 下一步
    updateNext() {
      updateNext({
        phone: this.updateForm.phone,
        code: this.updateForm.code,
      }).then((response) => {
        if (response.code === 200) {
          Toast.success("验证成功");
          this.phone = response.data;
          this.verShow1 = false;
          this.verShow2 = false;
          this.updateNext1 = false;
          this.updateNext2 = true;
        } else {
          Toast.fail(response.msg);
        }
      });
    },
    // 发送短信验证码
    sendSms() {
      if (!/^1[3456789]\d{9}$/.test(this.updateForm.phone)) {
        Toast.fail("请输入正确的手机号");
        return false;
      }
      sendSms({ phone: this.updateForm.phone }).then((response) => {
        if (response.code === 200) {
          // 发送成功
          Toast.success(response.msg);
          this.verShow1 = false;
          this.verShow2 = true;
          var auth_timer = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
              this.timer = 59;
              this.verShow1 = true;
              this.verShow2 = false;
              clearInterval(auth_timer);
            }
          }, 1000);
        } else {
          // 发送失败
          Toast.fail(response.msg);
          return false;
        }
      });
    },
    // 手机号码校验
    validatorPhonenumber(val) {
      return /(^[1][3,4,5,6,7,8,9][0-9]{9}$)/.test(val);
    },
    // 密码校验
    validatorPassword(val) {
      return /(^[a-zA-Z0-9]{6,10}$)/.test(val);
    },
    // 返回登录
    getBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.update {
  .header {
    .arrow-left {
      position: absolute;
      top: 3%;
      left: 5%;
      color: #fff;
      font-weight: 600;
    }
    img {
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
    }
  }
  .code {
    background: linear-gradient(
      to right,
      rgb(44, 93, 253) 0%,
      rgb(51, 161, 254) 100%
    );
    color: #fff;
    border-radius: 20px;
    padding: 10px;
  }
  .submit {
    background: linear-gradient(
      to right,
      rgb(44, 93, 253) 0%,
      rgb(51, 161, 254) 100%
    );
    color: #fff;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
  }
}
.van-form {
  margin-top: 30px;
}
</style>

<style lang="scss">
.van-icon__image {
  width: 1.5em !important;
  height: 1.5em !important;
  margin-left: -10px;
}
</style>
